import request from '@/utils/request'
import store from '@/store'
const url = store.getters.getPostUrl;
export default {
    getWorkloadStatistics() {
		return request({
			url: url + '/workOrder/getWorkloadStatistics',
			method: 'get'
		})
	},
	getCountByStateTggregate(params) {
		return request({
			url: url + '/workOrder/getWorkloadStatisticsTggregate',
			method: 'get',
			params: params
		})
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/statistics/statistics.js